(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('CustomRowTypeAttributeDeleteController',CustomRowTypeAttributeDeleteController);

    CustomRowTypeAttributeDeleteController.$inject = ['$uibModalInstance', 'entity', 'CustomRowTypeAttribute'];

    function CustomRowTypeAttributeDeleteController($uibModalInstance, entity, CustomRowTypeAttribute) {
        var vm = this;

        vm.customRowTypeAttribute = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            CustomRowTypeAttribute.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
